import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CloseIcon from '@mui/icons-material/Close';

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import uuid from "react-uuid";

import { validator } from "../../Js/Validator";
import { nameToJson } from "./Services";
import { formateName, updateUser } from "./Services";
import { loggedInUserInfoSliceActions } from "../../Store/Slices/LoggedInUserInfo";

const ProfileInfo = (props) => {
  // Hooks
  const dispatch = useDispatch();

  // State
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState("");
  const [designation, setDesignation] = useState("");

  const [newEmail, setNewEmail] = useState('');
  const [multipleEmail, setMultipleEmail] = useState([]);
  const [newPhoneNo, setNewPhoneNo] = useState('');
  const [multiplePhoneNo, setMultiplePhoneNo] = useState([]);

  const [gender, setGender] = useState("Male");
  const [validate, setValidate] = useState(false);
  const [nameError, setNameError] = useState(null);

  const [errorEmailMessage, setErrorEmailMessage] = useState(null);
  const [errorPhoneMessage, setErrorPhoneMessage] = useState(null);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  // React logic hooks
  useEffect(() => {
    setName(formateName(userInfo.name));
    setDesignation(userInfo.designation);
    if (userInfo.contact_details) {
      setMultipleEmail(userInfo.contact_details.cdetails.email);
      setMultiplePhoneNo(userInfo.contact_details.cdetails.phone);
    }
    setGender(userInfo.gender);
  }, [userInfo]);

  // Reset state
  const resetState = () => {
    setEditMode(false);
    setName(formateName(userInfo.name));
    setDesignation(userInfo.designation);    
    if (userInfo.contact_details) {
      setMultipleEmail(userInfo.contact_details.cdetails.email);
      setMultiplePhoneNo(userInfo.contact_details.cdetails.phone);
    }
    setGender(userInfo.gender);
    setNewEmail('');
    setNewPhoneNo('');

    setNameError(null);
    setErrorEmailMessage(null);
    setErrorPhoneMessage(null);
    setValidate(false);
  };

  // Validate name on blur
  const nameBlurValidate = () => {
    let validaten = validator({ required: true, value: name });
    if (!validaten["validate"]) {
      setNameError(validaten["message"]);
      setValidate(false);
    } else {
      setNameError(null);
      setValidate(true);
    }
  };

  // Validate email on blur
  const emailBlurValidate = () => {    
    if (newEmail) {
      let validatee = validator({
        pattern: `/^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/`,
        value: newEmail,
      });      
      if (!validatee["validate"]) {                
        setErrorEmailMessage(validatee["message"]);
        setValidate(false);
        return false;
      } else {        
        setErrorEmailMessage(null);
        setValidate(true);
        return true;
      }
    } else {
      setErrorEmailMessage(null);
      setValidate(true);
      return false;
    }
  };

  const handleEmailDetail = () => {
    let isValidate = emailBlurValidate();
    if (isValidate) {
      let newData = [...multipleEmail];
      let resNewData = newData.filter((obj) => { return (obj.email_address == newEmail.trim()) });
      if (resNewData.length == 0) {
        let emailData = {
          "uuid": uuid(),
          "type": "self",
          "context": "",
          "email_address": newEmail.trim(),
          "email_verified": false,
          "default": false,
          "social": [],
          "notification_flag": false
        };
        setMultipleEmail([...multipleEmail, emailData]);
        setNewEmail('');
        setErrorEmailMessage(null);
        setValidate(true);
        return
      } else {
        setErrorEmailMessage('Duplicate e-mail not allowed');
        setValidate(false);
        return;
      }
    }
  };

  

  const handlePhoneDetail = () => {
    let isValidate = phoneBlurValidate();
    if (isValidate) {
      let newData = [...multiplePhoneNo];
      let resNewData = newData.filter((obj) => { return (obj.phone_number == newPhoneNo.trim()) });
      if (resNewData.length == 0) {
        let phoneData = {
          "uuid": uuid(),
          "type": "self",
          "context": "",
          "country": "IN",
          "country_code": "+91",
          "phone_number": newPhoneNo.trim(),
          "extention": "",
          "phone_verified": false,
          "default": false,
          "social": [],
          "notification_flag": false
        };
        setMultiplePhoneNo([...multiplePhoneNo, phoneData]);
        setNewPhoneNo('');
        setErrorPhoneMessage(null);
        setValidate(false);
        return
      } else {
        setErrorPhoneMessage('Duplicate phone number not allowed');
        setValidate(true);
        return;
      }
    }
  };

  // Validate phone on blur
  const phoneBlurValidate = () => {
    if (newPhoneNo) {
      let validatep;
      validatep = validator({
        pattern: `/^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$/im`,
        value: newPhoneNo,
      });
      if (!validatep["validate"]) {
        setErrorPhoneMessage(validatep["message"]);
        setValidate(false);
        return false;
      } else {
        setErrorPhoneMessage(null);
        setValidate(true);
        return true;
      }
    } else {
      setErrorPhoneMessage(null);
      setValidate(true);
      return false;
    }
  };

  const removeChip = (index, type) => {
    if (type == 'email') {
      let newData = [...multipleEmail];
      newData.splice(index, 1);
      setMultipleEmail(newData);
    } else if (type == 'phone_number') {
      let newData = [...multiplePhoneNo];
      newData.splice(index, 1);
      setMultiplePhoneNo(newData);
    }
  };

  // Save changes
  const saveChanges = async () => {    
    if (validate) {
      let usersInfoObj = {
        name: nameToJson(name),
        designation: designation,
        contact_details: {
          cdetails: {
            email: multipleEmail,
            phone: multiplePhoneNo,
            email_notification_flag: false
          }
        },
        gender: gender,
      };
      console.log("22222", usersInfoObj);
      let userUpdate = await updateUser(
        usersInfoObj,
        userInfo.uid,
        userInfo.site_uuid
      );
      if (userUpdate.status == 200) {
        dispatch(loggedInUserInfoSliceActions.setUpdatedUserInfo(usersInfoObj));
        setEditMode(false);
      }
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container direction="row">
        <Grid item xs={6} sx={{ pr: 3 }}>
          <Typography sx={{ color: "#DB8829", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>Name: </Typography>
          <TextField
            size="small"
            required
            id="outlined-required"
            sx={{ backgroundColor: "#F5F5F5", borderRadius: 50 }}
            InputProps={{
              inputProps: { style: { fontSize: "0.8rem", color: "#DB8829" } },
              style: { borderRadius: 50 },
            }}
            value={name}
            onInput={(event) => {
              setName(event.target.value);
            }}
            onBlur={() => {
              nameBlurValidate();
            }}
            disabled={!editMode}
            placeholder={"Enter Name"}
            error={nameError}
            helperText={nameError}
          />
          <Typography sx={{ marginTop: 5, color: "#DB8829", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
            Email ID:
          </Typography>
          <TextField
            size="small"
            required
            id="outlined-required"
            sx={{ backgroundColor: "#F5F5F5", borderRadius: 50 }}
            InputProps={{
              inputProps: { style: { fontSize: "0.8rem", color: "#DB8829" } },
              style: { borderRadius: 50 },
            }}
            name={"newEmail"}
            value={newEmail}
            onInput={(event) => { setNewEmail(event.target.value) }}
            onBlur={() => { emailBlurValidate() }}
            onKeyDown={(event) => { if (event.keyCode === 13) { handleEmailDetail(); } }}
            disabled={!editMode}
            placeholder={"Enter Email ID"}
            error={errorEmailMessage}
            helperText={errorEmailMessage}
          />
          <Box sx={{ textAlign: 'left' }}>
            { multipleEmail.length > 0 &&
              multipleEmail.map((item, index) => {
                return (
                  <Chip
                    sx={{ mt: 1, fontSize: '0.8rem', backgroundColor: '#F5F5F5', color: 'primary.main', fontWeight: '500' }}
                    label={item.email_address}
                    disabled={!editMode}
                    onDelete={() => { removeChip(index, 'email') }}
                    deleteIcon={<CloseIcon />}
                    size="small" />
                )
              })
            }
          </Box>
        </Grid>

        <Grid item xs={6} sx={{ pr: 1, pl: 1 }}>
          <Typography sx={{ color: "#DB8829", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>Designation:</Typography>
          <TextField
            size="small"
            required
            id="outlined-required"
            sx={{ backgroundColor: "#F5F5F5", borderRadius: 50 }}
            InputProps={{
              inputProps: { style: { fontSize: "0.8rem", color: "#DB8829" } },
              style: { borderRadius: 50 },
            }}
            value={designation}
            onInput={(event) => {
              setDesignation(event.target.value);
            }}
            disabled={!editMode}
            placeholder={"Enter Designation"}
          />
          <Typography sx={{ marginTop: 5, color: "#DB8829", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
            Phone no:
          </Typography>
          <TextField
            size="small"
            required
            id="outlined-required"
            color="primary"
            sx={{ backgroundColor: "#F5F5F5", borderRadius: 50 }}
            InputProps={{
              inputProps: { style: { fontSize: "0.8rem", color: "#DB8829" } },
              style: { borderRadius: 50 },
            }}
            placeholder={"Enter Phone no:"}
            value={newPhoneNo}
            onInput={(event) => { setNewPhoneNo(event.target.value) }}
            onBlur={() => { phoneBlurValidate() }}
            onKeyDown={(event) => { if (event.keyCode === 13) { handlePhoneDetail() } }}
            disabled={!editMode}
            error={errorPhoneMessage}
            helperText={errorPhoneMessage}
          />
          <Box sx={{ textAlign: 'left' }}>
            { multiplePhoneNo.length > 0 &&
              multiplePhoneNo.map((item, index) => {
                return (
                  <Chip
                    sx={{ mt: 1, fontSize: '0.8rem', backgroundColor: '#F5F5F5', color: 'primary.main', fontWeight: '500' }}
                    label={item.phone_number}
                    disabled={!editMode}
                    onDelete={() => { removeChip(index, 'phone_number') }}
                    deleteIcon={<CloseIcon />}
                    size="small" />
                )
              })
            }
          </Box>
        </Grid>
        <Grid item xs={7} sx={{ pr: 1, pl: 1 }}>
          <FormControl>
            <FormLabel
              id="demo-radio-buttons-group-label"
              sx={{
                marginTop: 5, color: "#DB8829", fontWeight: '500', '@media (min-width: 1636px)': {
                  fontSize: '1.4rem'
                }
              }}
            >
              Gender
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
              row={true}
              value={gender}
              onChange={(event) => {
                setGender(event.target.value);
              }}
            >
              <FormControlLabel
                value="Female"
                control={<Radio />}
                label="Female"
                disabled={!editMode}
              />
              <FormControlLabel
                value="Male"
                control={<Radio />}
                label="Male"
                disabled={!editMode}
              />
              <FormControlLabel
                value="Other"
                control={<Radio />}
                label="Other"
                disabled={!editMode}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" justifyContent={"flex-end"}>
        {!editMode && (
          <Button
            variant="contained"
            size="small"
            sx={{
              px: 5,
              mt: 6,
              borderRadius: 15,
              backgroundColor: "primary.main",
              color: "#FFFFFF",
              height: "2rem",
              textTransform: "inherit",
              '@media (min-width: 1636px)': { fontSize: '1.4rem', height: "3rem" },
             
            }}
            onClick={() => {
              setEditMode(true);
              setValidate(true);
            }}
          >
            Edit
          </Button>
        )}
        {editMode && (
          <>
            <Button
              variant="contained"
              size="small"
              sx={{
                px: 5,
                mt: 6,
                mr: 3,
                borderRadius: 15,
                backgroundColor: "primary.main",
                color: "#FFFFFF",
                height: "2rem",
                textTransform: "inherit",
                '@media (min-width: 1636px)': {
                  fontSize: '1.4rem',
                  height: "3rem",
                },
               
              }}
              onClick={() => {
                resetState();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              sx={{
                px: 5,
                mt: 6,
                borderRadius: 15,
                backgroundColor: "primary.main",
                color: "#FFFFFF",
                height: "2rem",
                textTransform: "inherit",
                '@media (min-width: 1636px)': { fontSize: '1.4rem', height: "3rem" },
              
              }}
              onClick={() => {
                saveChanges();
              }}
            >
              Save
            </Button>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default ProfileInfo;
